import { Button, Card, CardContent, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { AdsService } from '../../Services/ads.service';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { useLoadingContext } from '../../context/loadingContext';

const EditAds = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const [ads, setAds] = useState({})
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [image, setImage] = useState();
    const [imageReview, setImageReview] = useState();
    const { handleStartLoading, handleStopLoading } = useLoadingContext();


    useEffect(() => {
        getAdsById().finally(handleStopLoading);
    }, []);

    const getAdsById = async () => {
        handleStartLoading();
        const adsData = await AdsService.GetAdsId(id);
        setAds(adsData)
        setTitle(adsData.title);
        setUrl(adsData.url);
        setImageReview(`${process.env.REACT_APP_IMAGE}${adsData.image}`);

    };

    const handleEditClick = async () => {
        const form = new FormData();
        form.append('title', title);
        form.append('url', url);
        form.append('image', image);
        try {
            handleStartLoading();
            await AdsService.EditAds(id, form);
            navigate(`/ctkm`, { replace: true, state: '/ctkm' });
            enqueueSnackbar('Cập nhật thành công', { variant: 'success' });
        } catch (error) {
            console.log(error)
        } finally{
            handleStopLoading()
        }
    }

    const handleCancelClick = () => {
        navigate(-1);
    };

    const handleAvatarChange = (e) => {
        const img = e.target.files[0];
        const review = URL.createObjectURL(img);
        setImageReview(review);
        setImage(img);
    };

    return (
        <Page title="Create event">
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Thêm khuyến mãi mới
                    </Typography>
                    <Stack direction={'row'} spacing={1}>
                        <Button
                            type="button"
                            onClick={handleCancelClick}
                            color="error"
                            variant="contained"
                            startIcon={<Iconify icon="iconoir:cancel" />}
                        >
                            Cancel
                        </Button>
                        <Button
                            //   disabled={isSubmitting} 
                            onClick={handleEditClick}
                            type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                            Save
                        </Button>
                    </Stack>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                            <Grid item xs={12} md={8}>
                                <Stack spacing={3}>
                                    <TextField id="outlined-basic" label="Title" variant="outlined"
                                        value={title}
                                        onChange={e => setTitle(e.target.value)}
                                    />
                                    <TextField id="outlined-basic" label="Url" variant="outlined"
                                        value={url}
                                        onChange={e => setUrl(e.target.value)}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Button
                                    // disabled={isSubmitting}
                                    sx={{ border: '1px dashed gray' }}
                                    color="primary"
                                    aria-label="upload picture"
                                    component="label"
                                >
                                    <input
                                        onChange={handleAvatarChange}
                                        hidden accept="image/*" type="file" />
                                    {imageReview ? (
                                        <img
                                            src={imageReview}
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <img
                                            src="/static/noimage.jpeg"
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    )}
                                </Button>
                                <Typography variant="body2" display="block" sx={{opacity: '0.6'}}>Kích thước: 900x600</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    )
}

export default EditAds